require('fg-frontend/third/highslide/highslide-full');

var hs = window.hs;

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = 'rounded-black';
hs.align = 'center';
hs.dimmingOpacity = 1;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
//hs.captionEval = 'this.a.title';

if ($('html').attr('lang') == 'cs') {
    hs.lang.loadingText = 'Nahrává se...';
    hs.lang.loadingTitle = 'Kliknutím zrušit';
    hs.lang.focusTitle = 'Kliknutím přenést vpřed';
    hs.lang.fullExpandTitle = 'Zvětšit na původní velikost[F]';
    hs.lang.previousText = 'Předchozí';
    hs.lang.nextText = 'Další';
    hs.lang.moveText = 'Přesunout';
    hs.lang.closeText = 'Zavřít';
    hs.lang.closeTitle = 'Zavřít [ESC]';
    hs.lang.resizeTitle = 'Změnit velikost';
    hs.lang.playText = 'Spustit slideshow';
    hs.lang.playTitle = 'Spustit slideshow [MEZERNÍK]';
    hs.lang.pauseText = 'Pauza';
    hs.lang.pauseTitle = 'Pauza [MEZERNÍK]';
    hs.lang.previousTitle = 'Předchozí [ŠIPKA VLEVO]';
    hs.lang.nextTitle = 'Další [ŠIPKA VPRAVO]';
    hs.lang.moveTitle = 'Přesunout';
    hs.lang.fullExpandText = 'Plná velikost';
    hs.lang.number = 'Obrázek %1 z %2';
    hs.lang.restoreTitle = 'Kliknutím zavřít obrázek, kliknutím a tažením přesunout.';
}

if ($('html').attr('lang') == 'sk') {
    hs.lang.loadingText = 'Nahráva sa ...';
    hs.lang.loadingTitle = 'Kliknutím zrušiť';
    hs.lang.focusTitle = 'Kliknutím preniesť vpred';
    hs.lang.fullExpandTitle = 'Zväčšiť na pôvodnú veľkosť [F]';
    hs.lang.previousText = 'Predchádzajúca';
    hs.lang.nextText = 'Ďalší';
    hs.lang.moveText = 'Presunúť';
    hs.lang.closeText = 'Zavrieť';
    hs.lang.closeTitle = 'Zavrieť [ESC]';
    hs.lang.resizeTitle = 'Zmeniť veľkosť';
    hs.lang.playText = 'Spustiť slideshow';
    hs.lang.playTitle = 'Spustiť slideshow [MEDZERNÍK]';
    hs.lang.pauseText = 'Pauza';
    hs.lang.pauseTitle = 'Pauza [MEDZERNÍK]';
    hs.lang.previousTitle = 'Predchádzajúci [ŠÍPKA VĽAVO]';
    hs.lang.nextTitle = 'Ďalšie [ŠÍPKA VPRAVO]';
    hs.lang.moveTitle = 'Presunúť';
    hs.lang.fullExpandText = 'Plná veľkosť';
    hs.lang.number = 'Obrázok% 1 z% 2';
    hs.lang.restoreTitle = 'Kliknutím zavrieť obrázok, kliknutím a ťahaním presunúť.';
}

if (hs.registerOverlay) {
    hs.registerOverlay({
        fade: 2,
        hideOnMouseOut: false,
        html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">'+ hs.lang.closeText +'</a>',
        useOnHtml: true,
        position: 'top right'
    });
}


hs.Expander.prototype.onBeforeExpand = function(sender) {

	//jen pro obrazky
	if (sender.a.className.indexOf("hs-htmlExpand") < 0) {

		// dynamicka navigace mezi fotkami

		var arrowLeft = document.createElement('div');
		var arrowRight = document.createElement('div');

		if (sender.getAdjacentAnchor(-1)) {
			arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="' + hs.lang.previousText + '" class="highslide-previous"><span class="glyphicon glyphicon-arrow"></span></a>';
			arrowLeft.className = "controlbar-arrows";
		}
		if (sender.getAdjacentAnchor(1)) {
			arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="' + hs.lang.nextText + '" class="highslide-next"><span class="glyphicon glyphicon-arrow"></span></a>';
			arrowRight.className = "controlbar-arrows";
		}
		if (arrowLeft.innerHTML != "") {
			sender.createOverlay({ overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
		}
		if (arrowRight.innerHTML != "") {
			sender.createOverlay({ overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
		}
	}

	//jen pro formy
	if (sender.a.className.indexOf('hs-form') > -1) {
		hs.onDimmerClick = function() {
			return false;
		}
	}
};

hs.Expander.prototype.onAfterExpand = function(sender) {
	if (sender.custom && sender.custom.disableKeys) {
		hs.enableKeyListener = false;
	}
}
hs.Expander.prototype.onAfterClose = function (sender) {
	if (sender.custom && sender.custom.disableKeys) {
		hs.enableKeyListener = true;
	}
};



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/highslide-settings.js